import { ENV } from '../../config/runtimeEnv';
import { MedicationCatalogItem } from '../../types/healthcare/MedicationCatalogTypes';
import type { UserUuid } from '../../types/identity';
import { http } from '../../lib/http/client';

const BASE = ENV.VITE_HEALTHCARE_SERVER;

export interface CatalogIndexParams {
	company?: string;
	search?: string;
	category?: string;
	high_risk?: boolean;
	controlled?: boolean;
	include_inactive?: boolean;
}

export const fetchCatalogMedications = async (
	params: CatalogIndexParams
): Promise<MedicationCatalogItem[]> => {
	const res = await http.get(`${BASE}/practitioner/medications-catalog`, {
		params,
	});
	return res.data.data;
};

export const fetchCatalogMedication = async (id: number): Promise<MedicationCatalogItem> => {
	const res = await http.get(`${BASE}/practitioner/medications-catalog/${id}`);
	return res.data.data;
};

export const createCatalogMedication = async (
	data: Partial<MedicationCatalogItem>
): Promise<MedicationCatalogItem> => {
	const res = await http.post(`${BASE}/practitioner/medications-catalog`, data);
	return res.data.data;
};

export const updateCatalogMedication = async (
	id: number,
	data: Partial<MedicationCatalogItem>
): Promise<MedicationCatalogItem> => {
	const res = await http.put(`${BASE}/practitioner/medications-catalog/${id}`, data);
	return res.data.data;
};

export const deleteCatalogMedication = async (id: number): Promise<void> => {
	await http.delete(`${BASE}/practitioner/medications-catalog/${id}`);
};

export const toggleCatalogMedicationActive = async (
	id: number
): Promise<MedicationCatalogItem> => {
	const res = await http.patch(
		`${BASE}/practitioner/medications-catalog/${id}/toggle-active`,
		{}
	);
	return res.data.data;
};

export const fetchCatalogCategories = async (company?: string): Promise<string[]> => {
	const res = await http.get(`${BASE}/practitioner/medications-catalog/categories`, {
		params: { company },
	});
	return res.data.data;
};

export const assignCatalogMedicationToPatient = async (
	catalogId: number,
	payload: {
		patient_id: UserUuid;
		prescribed_by: UserUuid;
		start_date: string;
		end_date?: string;
		dosage?: string;
		frequency?: string;
		instructions?: string;
	}
): Promise<any> => {
	const res = await http.post(
		`${BASE}/practitioner/medications-catalog/${catalogId}/assign-to-patient`,
		payload
	);
	return res.data.data;
};